import { useMutation, useQueryClient } from "@tanstack/react-query"

import { client } from "@/api"
import { SlotFormFormDataType } from "@/components/advertisements/SlotForm"
import queryKeys from "@/api/queryKeys"

function useUpdateAdvertisementSlots() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (data: SlotFormFormDataType) => {
      return client
        .put(`/advertisements/slots`, data)
        .then((response) => response.data)
    },
    onSuccess: () => {
      queryClient.fetchQuery({
        queryKey: queryKeys.advertisements.list({}).queryKey,
      })
    },
  })
}
export default useUpdateAdvertisementSlots
